import type { Transfer } from '../store';
import { dismissTransfer } from '../term/drops';

/** A note about files dropped into the session (one toast in the pane's stack; see term/drops.ts). The upload itself is UploadBanner's. */
export function TransferToast({ t }: { t: Transfer }) {
  return (
    <div className="toast-card transfer is-notice" role="status" data-testid="transfer-notice">
      <span className="toast-icon" aria-hidden="true">
        i
      </span>
      <span className="transfer-text" title={t.text}>
        {t.text}
      </span>
      <button className="transfer-x" aria-label="Dismiss" onClick={() => dismissTransfer(t.id)} data-testid="transfer-dismiss">
        ✕
      </button>
    </div>
  );
}
